import React from 'react';
import DefaultDemoPresenter from './DefaultDemoPresenter';
import MobileDemoPresenter from './MobileDemoPresenter';
import {Default,Mobile} from '../../Sizes';

function QuizDemoPresenter(props){
	return (
		<React.Fragment>
			<Default>
				<DefaultDemoPresenter {...props} />
			</Default>
			<Mobile>
				<MobileDemoPresenter {...props} />
			</Mobile>
		</React.Fragment>
	);
}

export default QuizDemoPresenter;